import './CATREQ.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CATREQ extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initScrollToCatalogDownload();
		this.initCatalogRequestForm();
	}

	async initScrollToCatalogDownload () {
		const triggerElements = document.getElementsByClassName('js-scroll-to-catalog-download');

		if (!triggerElements.length) {
			return;
		}

		const {default: ScrollTo} = await import('extensions/scroll-to');

		new ScrollTo(triggerElements, {
			scrollIntoViewOptions: {
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest'
			}
		});
	}

	initCatalogRequestForm () {
		const catalogRequestElement = document.getElementById('js-catalog-form');

		if (!catalogRequestElement) {
			return;
		}

		catalogRequestElement.addEventListener('submit', this.handleCatalogRequestFormSubmit.bind(this));
	}

	// eslint-disable-next-line max-lines-per-function
	async handleCatalogRequestFormSubmit (event) {
		const formElement = event.target;

		if (!formElement) {
			return;
		}

		const submitElement = formElement.querySelector('[type="submit"]');
		const formAction = formElement.getAttribute('action');

		if (!submitElement || !formAction) {
			return;
		}

		event.preventDefault();

		const messageElements = formElement.getElementsByClassName('g-catalog-request-form__message');

		for (const messageElement of messageElements) {
			messageElement.classList.add('u-hidden');
		}

		submitElement.disabled = true;
		submitElement.classList.add('g-button--submitting');

		const response = await fetch(formAction, {
			body: new FormData(formElement),
			method: 'post'
		});

		submitElement.disabled = false;
		submitElement.classList.remove('g-button--submitting');

		let messageElement = document.getElementById('js-catalog-request-success-message');

		if (response.ok) {
			formElement.reset();
		} else {
			messageElement = document.getElementById('js-catalog-request-error-message');
		}

		if (!messageElement) {
			return;
		}

		messageElement.classList.remove('u-hidden');

		messageElement.scrollIntoView({
			behavior: 'smooth',
			block: 'center'
		});
	}
}
